import React, { useMemo } from 'react';
import { useGPS } from '../../contexts/GPSContext';
import { GPS_CUSTOM_FILTERS } from '../../constants/gpsFilters';
import GPSFilterSelect from './GPSFilterSelect';
import { getFilterLayout } from './gpsFilters.config';

const GPSAdvancedFiltersPanel = ({ jail = false, onReset, onApply }) => {
  const gps = useGPS();
  const { advanced } = getFilterLayout(gps, jail);

  const customFilterOptions = useMemo(
    () => [
      { value: GPS_CUSTOM_FILTERS.REQUEST_COMPLIANT, label: 'Demande conforme' },
      { value: GPS_CUSTOM_FILTERS.REQUEST_NON_COMPLIANT, label: 'Demande non conforme' },
      { value: GPS_CUSTOM_FILTERS.INTERVENTION_COMPLIANT, label: 'Intervention conforme' },
      { value: GPS_CUSTOM_FILTERS.INTERVENTION_NON_COMPLIANT, label: 'Intervention non conforme' },
      { value: GPS_CUSTOM_FILTERS.OUT_OF_DATE, label: 'Hors délai' },
      { value: GPS_CUSTOM_FILTERS.PARTIAL, label: 'Partiel' },
    ],
    []
  );

  const selectedCustom = gps.selectedCustomFilters || [];
  const isCustomSelected = (value) => selectedCustom.some((f) => f.value === value);

  const toggleCustom = (option) => {
    if (isCustomSelected(option.value)) {
      gps.setSelectedCustomFilters(selectedCustom.filter((f) => f.value !== option.value));
    } else {
      gps.setSelectedCustomFilters([...selectedCustom, option]);
    }
  };

  return (
    <div className="mt-2.5 bg-[#faf9ff] dark:bg-[#1a1726] border border-[#ece8fd] dark:border-gray-900 rounded-xl p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {advanced.map((def) => (
          <GPSFilterSelect key={def.key} def={def} gps={gps} />
        ))}
      </div>

      {/* Custom (compliance) filters as toggle chips */}
      <div className="mt-4 pt-3.5 border-t border-[#ece8fd] dark:border-gray-900">
        <div className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2.5">
          Filtres personnalisés {selectedCustom.length > 0 ? `(${selectedCustom.length})` : ''}
        </div>
        <div className="flex flex-wrap gap-2">
          {customFilterOptions.map((opt) => {
            const active = isCustomSelected(opt.value);
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => toggleCustom(opt)}
                className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-lg px-3 py-1.5 border transition-colors ${
                  active
                    ? 'text-[#5b3df0] dark:text-[#a98ff5] bg-white dark:bg-[#241f36] border-[#ddd4fb] dark:border-[#3a3354]'
                    : 'text-gray-600 dark:text-gray-300 bg-white dark:bg-[#1e1e1e] border-gray-200 dark:border-gray-700 hover:border-[#ddd4fb]'
                }`}
              >
                {opt.label}
                {active && (
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      </div>

      <div className="flex items-center gap-3 mt-4">
        <span className="text-xs text-gray-400 dark:text-gray-500">
          Les filtres s'appliquent en direct.
        </span>
        <div className="ml-auto flex gap-2.5">
          <button
            type="button"
            onClick={onReset}
            className="bg-white dark:bg-[#1e1e1e] border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 rounded-lg px-4 py-2 text-xs font-semibold hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            Réinitialiser
          </button>
          <button
            type="button"
            onClick={onApply}
            className="bg-[#5b3df0] hover:bg-[#4c30d6] text-white rounded-lg px-4 py-2 text-xs font-semibold transition-colors"
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default GPSAdvancedFiltersPanel;
